window.bundleDataP = {
"Paige-girl": {
displayName: "Paige",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Paige Personalized Coloring Experience",
variantId: "49279572246765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Paige_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Paige Unicorn Holographic Sticker",
variantId: "49933774094573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Paige_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Paige Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Paisley-girl": {
displayName: "Paisley",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Paisley Personalized Coloring Experience",
variantId: "49616975167725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Paisley_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Paisley Unicorn Holographic Sticker",
variantId: "49933755810029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Paisley_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Paisley Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Palmer-girl": {
displayName: "Palmer",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Palmer Personalized Coloring Experience",
variantId: "49754311262445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Palmer_final_cover.png?v=1775322362",
price: "$14.99",
preorder: true
},
{
title: "Palmer Unicorn Holographic Sticker",
variantId: "49933753123053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Palmer_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Palmer Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Parker-boy": {
displayName: "Parker",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Parker Personalized Coloring Experience",
variantId: "49411967844589",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/PARKER_FINAL_COVER.png?v=1772032667",
price: "$14.99",
preorder: true
},
{
title: "Parker Dragon Holographic Sticker",
variantId: "49933767246061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Parker_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Parker Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Penelope-girl": {
displayName: "Penelope",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Penelope Personalized Coloring Experience",
variantId: "49279572345069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Penelope_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Penelope Unicorn Holographic Sticker",
variantId: "49933774029037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Penelope_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Penelope Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Perry Ann-girl": {
displayName: "Perry Ann",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Perry Ann Personalized Coloring Experience",
variantId: "49929641558253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Perry_Ann_final_cover.png?v=1777857546",
price: "$14.99",
preorder: true
},
{
title: "Perry Ann Unicorn Holographic Sticker",
variantId: "49933745979629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/PerryAnn_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Perry Ann Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Peyton-girl": {
displayName: "Peyton",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Peyton Personalized Coloring Experience",
variantId: "49299054035181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Peyton_final_cover.png?v=1773766537",
price: "$14.99",
preorder: true
},
{
title: "Peyton Unicorn Holographic Sticker",
variantId: "49933772947693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Peyton_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Peyton Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Phil-boy": {
displayName: "Phil",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Phil Personalized Coloring Experience",
variantId: "49472209125613",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Phil_final_cover.png?v=1772930017",
price: "$14.99",
preorder: true
},
{
title: "Phil Dragon Holographic Sticker",
variantId: "49933758890221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Phil_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Phil Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Phoebe-girl": {
displayName: "Phoebe",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Phoebe Personalized Coloring Experience",
variantId: "49971421839597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Phoebe_final_cover.png?v=1777863211",
price: "$14.99",
preorder: true
},
{
title: "Phoebe Unicorn Holographic Sticker",
variantId: "49945845924077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Phoebe_holographic_sticker.png?v=1779378945",
price: "$4.99",
preorder: false
},
{
title: "Phoebe Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Piper-girl": {
displayName: "Piper",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Piper Personalized Coloring Experience",
variantId: "49279572443373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Piper_final_cover.png?v=1773766535",
price: "$14.99",
preorder: true
},
{
title: "Piper Unicorn Holographic Sticker",
variantId: "49933773996269",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Piper_holographic_ssticker.png?v=1780099047",
price: "$4.99",
preorder: false
},
{
title: "Piper Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Poppy-girl": {
displayName: "Poppy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Poppy Personalized Coloring Experience",
variantId: "49616975921389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Poppy_final_cover.png?v=1773443858",
price: "$14.99",
preorder: true
},
{
title: "Poppy Unicorn Holographic Sticker",
variantId: "49933755744493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Poppy_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Poppy Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Parker-girl": {
displayName: "Parker",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Parker Personalized Coloring Experience",
variantId: "50078214881517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Parker_girl_final_cover.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Parker Unicorn Holographic Sticker",
variantId: "50077629022445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Parker_girl_sticker_website.png?v=1780804205",
price: "$4.99",
preorder: false
},
{
title: "Parker Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Peter-boy": {
displayName: "Peter",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Peter Personalized Coloring Experience",
variantId: "50180879581421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Peter_final_cover.png?v=1782611298",
price: "$14.99",
preorder: true
},
{
title: "Peter Dragon Holographic Sticker",
variantId: "50180778918125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Peterwebsitesticker.png?v=1782610006",
price: "$4.99",
preorder: false
},
{
title: "Peter Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Patrick-boy": {
displayName: "Patrick",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Patrick Personalized Coloring Experience",
variantId: "50399309824237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Patrick_final_cover.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Patrick Dragon Holographic Sticker",
variantId: "50399525798125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Patrick_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Patrick Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Paul-boy": {
displayName: "Paul",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Paul Personalized Coloring Experience",
variantId: "50399844270317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Paulfinalcover.png?v=1785906054",
price: "$14.99",
preorder: true
},
{
title: "Paul Dragon Holographic Sticker",
variantId: "50449551917293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Paulholographicsticker.png?v=1786250184",
price: "$4.99",
preorder: false
},
{
title: "Paul Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Preston-boy": {
displayName: "Preston",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Preston Personalized Coloring Experience",
variantId: "50399855837421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Prestonfinalcover.png?v=1785906444",
price: "$14.99",
preorder: true
},
{
title: "Preston Dragon Holographic Sticker",
variantId: "50449555980525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Preston_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Preston Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Phoenix-boy": {
displayName: "Phoenix",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Phoenix Personalized Coloring Experience",
variantId: "50449691050221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Phoenix_final_cover.png?v=1786244941",
price: "$14.99",
preorder: true
},
{
title: "Phoenix Dragon Holographic Sticker",
variantId: "50449587306733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Phoenix_holographic_sticker.png?v=1786244664",
price: "$4.99",
preorder: false
},
{
title: "Phoenix Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Paxton-boy": {
displayName: "Paxton",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Paxton Personalized Coloring Experience",
variantId: "50457718194413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Paxton_final_cover.png?v=1786406748",
price: "$14.99",
preorder: true
},
{
title: "Paxton Dragon Holographic Sticker",
variantId: "50457561170157",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Paxton_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Paxton Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Presley-girl": {
displayName: "Presley",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Presley Personalized Coloring Experience",
variantId: "50519294771437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Presley_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Presley Unicorn Holographic Sticker",
variantId: "50497565884653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Presley_girl_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Presley Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 









};